import React, { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import PageLoader from "src/components/PageLoader/PageLoader";
import FormInput from "src/components/shared/Forms/FormInput/FormInput";
import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { URL_CONSTANTS } from "src/constants/url.constants";
import { usePassword } from "src/hooks/profile/usePassword";
import { commonLocales } from "src/locales/commonLocales";
import { locales } from "src/locales/indexLocales";
import { resetPasswordField } from "src/utils/formData/password.data";

import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CRow,
} from "@coreui/react";

const ResetPassword: React.FC = () => {
  const { loading, resetPasswordMethods, passwordSubmit, userToken } =
    usePassword();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    !userToken &&
      navigate(URL_CONSTANTS.HOME, { replace: CONSTANTS.COMMON_CONSTANTS.YES });
  }, [pathname]);
  return userToken ? (
    <>
      <PageLoader isLoading={loading} />
      <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol md={7} lg={6} xl={5} className="p-0">
              <div className="dd-header p-0 position-relative">
                <div className="wrapLogo">
                  <img
                    className="dd-logo"
                    src={COMMON_CONSTANTS.LOGIN_FORM_LOGO}
                    alt="dental dynamic staffing"
                  />
                </div>
              </div>
              <CCardGroup>
                <CCard className="p-4 ">
                  <CCardBody>
                    <FormProvider {...resetPasswordMethods}>
                      <form
                        onSubmit={resetPasswordMethods.handleSubmit(
                          passwordSubmit
                        )}
                      >
                        <h4 className="fw-bold pt-2">
                          {commonLocales.resetPasswordHeading}
                        </h4>
                        <FormInput field={resetPasswordField.password} />
                        <FormInput field={resetPasswordField.confirmPassword} />
                        <CRow>
                          <CCol className="d-flex justify-content-end">
                            <CButton
                              className="px-4 dd-login-button"
                              type="submit"
                            >
                              {locales.setPassword}
                            </CButton>
                          </CCol>
                        </CRow>
                      </form>
                    </FormProvider>
                  </CCardBody>
                </CCard>
              </CCardGroup>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </>
  ) : (
    <></>
  );
};

export default ResetPassword;
